import { readable } from 'svelte/store';

export const CONTRACT_ADDRESS = readable(
	'0x6A3661Ddf23f2b1cf5751eafA39047eFc6e43c58'
);

export const transformCharacterData = (characterData) => {
	return {
		name: characterData.name,
		imageURI: characterData.imageURI,
		hp: characterData.hp.toNumber(),
		maxHp: characterData.maxHp.toNumber(),
		attackDamage: characterData.attackDamage.toNumber(),
	};
};
